import { render } from "./Switch.vue?vue&type=template&id=3e05dde5&scoped=true"
import script from "./Switch.vue?vue&type=script&lang=js"
export * from "./Switch.vue?vue&type=script&lang=js"

import "./Switch.vue?vue&type=style&index=0&id=3e05dde5&scoped=true&lang=css"

import exportComponent from "C:\\Git_repos\\blendify\\blendify-client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e05dde5"]])

export default __exports__